import React, { useState } from 'react';
import { string } from 'prop-types';
import { get, last } from 'lodash';
import { DrawerHeader, Drawer, Column, AlertLabel, Loading } from '../../common';
import { _get } from '../../../utils/misc';
import OrderQr from './OrderQr';
import QueryOrderQr from '../../graphql/getOrderQrById';
import { getQrStatusValues } from '../../../utils/misc';

const OrderQrStatus = ({ numOrder, id, storeName }) => {
    const errorStatus = getQrStatusValues('error');  
    const successStatus = getQrStatusValues('success');
    const [drawerOrderQr, setDrawerOrderQr] = useState(false);

    const closeDrawerOrderQr = () => setDrawerOrderQr(false);
    const toggleDrawerOrderQr = () => setDrawerOrderQr(!drawerOrderQr);

    const getDrawerOrderQrTitle = (actionNumber) => {
        if (successStatus.includes(actionNumber)) return 'QR generado con exito';
        if (errorStatus.includes(actionNumber)) return 'Problema QR - Puerta Bloqueada';
        return 'QR sin datos';
    };

    const renderAlertButton = (actionNumber) => {
        console.log("actionNumber")
        if (successStatus.includes(actionNumber)) {
            return <AlertLabel type="success" text="QR generado con exito" width={'auto'}  onClick={toggleDrawerOrderQr} />;
        }
        if (errorStatus.includes(actionNumber)) {
            return <AlertLabel type="error" text="Problema QR - puerta bloqueada" width={'auto'} onClick={toggleDrawerOrderQr} />;
        }
        return null;
    };

    return (
        <QueryOrderQr numOrder={numOrder}>
            {({ data: orderQr }) => {
                const actionNumber = get(last(orderQr), 'actionNumber', 0);

                if (!actionNumber || actionNumber === 0) return null;

                return (
                    <>
                        {renderAlertButton(actionNumber)}
                        <Drawer
                            values={['40%', '40%', '100%']}
                            visible={drawerOrderQr}
                            maskClosable
                            onClose={closeDrawerOrderQr}
                        >
                            {drawerOrderQr && (
                                <Column>
                                    <DrawerHeader 
                                        title={getDrawerOrderQrTitle(actionNumber)} 
                                        onClose={closeDrawerOrderQr} 
                                        titleProps={{ style: { fontWeight: 'bold', fontSize: '1.15rem', } }} 
                                    />
                                    <OrderQr
                                        dataQr={orderQr}
                                        id={id}
                                        storeName={storeName}
                                        isErrorQr = {errorStatus.includes(actionNumber)} 
                                        onClose={closeDrawerOrderQr}
                                    />
                                </Column>
                            )}
                        </Drawer>
                    </>
                );
            }}
        </QueryOrderQr>
    );
};

OrderQrStatus.propTypes = {
    numOrder: string,
    storeName: string,
    id: string,
};

OrderQrStatus.defaultProps = {
    numOrder: '0',
};

export default OrderQrStatus;